define(
	'busy',['require'],function(Busy) {
		// console.log('Busy');
		//--
		// var busy = $('.busy');
		//--
		var Data =
		{
			Show:
			function(){
				//--
				var busy = $('.busy');
				//--
				// console.info("Busy: Function : Show");

				//--
				if(busy.hasClass('busy_quit')){
					//--
					busy.removeClass('busy_quit busy_hide');
				}

				//--
				setTimeout(function(){
					busy.addClass('busy_show');
				}, 200);

				//--
				return true;
			}
			,
			Hide:
			function(){
				//--
				var busy = $('.busy');
				//--
				// console.info("Busy: Function : Hide");

				//--
				if(busy.hasClass('busy_show')){
					//--
					busy.removeClass('busy_show');
					busy.addClass('busy_hide');
				}

				//--
				setTimeout(function(){
					busy.addClass('busy_quit');
				}, 200);

				//--
				return true;
			}
		}

		//--
		return Data;
	}
);
